import { defineMessages } from "react-intl";

const messages = defineMessages({
  configure: {
    id: "csvUpload.configure",
  },
});

export default messages;
